/**
 * Génération d'identifiants uniques pour les enregistrements créés côté client
 * (souvenirs déposés par les invités, messages du livre d'or, notifications…).
 */

/** Construit un identifiant conforme à la RFC 4122 v4 sans passer par `crypto.randomUUID`. */
function randomUuidFallback(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  // Force les bits de version (4) et de variante (RFC 4122), comme le ferait randomUUID.
  const byte6 = bytes[6] ?? 0;
  const byte8 = bytes[8] ?? 0;
  bytes[6] = (byte6 & 0x0f) | 0x40;
  bytes[8] = (byte8 & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
}

/** Produit un identifiant `<prefix>-<uuid>` unique côté client. */
export function createId(prefix: string): string {
  const uuid = typeof crypto.randomUUID === "function" ? crypto.randomUUID() : randomUuidFallback();
  return `${prefix}-${uuid}`;
}
